var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Transition } from '@headlessui/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useMemo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createPortal } from 'react-dom';
import { GrClose } from 'react-icons/gr';
import { twMerge } from 'tailwind-merge';
import { createDrawerContext } from './Drawer.helpers';
var DrawerContext = createDrawerContext();
var useDrawerContext = function () { return React.useContext(DrawerContext); };
var Drawer = function (_a) {
    var show = _a.show, toggle = _a.toggle, _b = _a.portalId, portalId = _b === void 0 ? 'modal-portal-container' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, className = _a.className, children = _a.children, testSelector = _a.testSelector;
    var context = useMemo(function () { return ({
        show: show,
        toggle: toggle,
        testSelector: testSelector,
    }); }, [show]);
    return createPortal(_jsx(DrawerContext.Provider, { value: context, children: _jsx(DrawerContainer, { size: size, className: className, children: children }) }), document.querySelector("#".concat(portalId)));
};
var DrawerContainer = function (_a) {
    var size = _a.size, className = _a.className, children = _a.children;
    var _b = useDrawerContext(), show = _b.show, toggle = _b.toggle, testSelector = _b.testSelector;
    return (_jsxs(Transition, { show: show, className: "z-50 flex justify-end w-screen h-screen overflow-hidden transition-opacity duration-300 bg-zinc-800 bg-opacity-40", enterFrom: "opacity-0", enterTo: "opacity-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", "data-cy": testSelector, children: [_jsx("div", __assign({ className: "flex-grow h-full", onClick: toggle }, (testSelector ? { 'data-cy': "".concat(testSelector, "-close-alt") } : {}))), _jsx(Transition.Child, { as: "aside", className: twMerge('h-full z-50 transition-transform duration-300 shadow-lg bg-white flex flex-col w-full', size === 'sm' && 'sm:w-[500px]', size === 'md' && 'md:w-[650px]', size === 'lg' && 'lg:w-[800px]', className), enterFrom: "translate-x-full delay-200", enterTo: "translate-x-0 delay-200", leaveFrom: "translate-x-0", leaveTo: "translate-x-full", children: children })] }));
};
var DrawerTitle = function (_a) {
    var title = _a.title, className = _a.className, children = _a.children;
    var _b = useDrawerContext(), toggle = _b.toggle, testSelector = _b.testSelector;
    return (_jsxs("div", { className: twMerge('py-3.5 relative', className), children: [title && (_jsx("h2", { className: "w-full m-0 text-2xl font-light tracking-wide text-center", children: title })), _jsx(GrClose, __assign({ className: "box-content absolute right-0.5 p-4 text-xl cursor-pointer top-1", onClick: toggle }, (testSelector ? { 'data-cy': "".concat(testSelector, "-close") } : {}))), children] }));
};
var DrawerContent = function (_a) {
    var className = _a.className, children = _a.children;
    return (_jsx("div", { className: twMerge('flex-grow p-4 overflow-x-hidden overflow-y-auto bg-gradient-to-b from-white to-slate-200', className), children: children }));
};
Drawer.Title = DrawerTitle;
Drawer.Content = DrawerContent;
export { Drawer as default };
